import React from 'react';
import { Link } from 'react-router-dom';
import { Footer as UIFooter } from '@voilajsx/uikit/footer';
import { route } from '../utils';

const APP_NAME = import.meta.env.VITE_APP_NAME === 'plotmagic' ? 'PlotMagic' : 'RRD Planners';
const FOOTER_NAME = 'RRD Planners and Constructions';

const footerLinks = [
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
  { label: 'Terms', href: '/terms' },
  { label: 'Privacy', href: '/privacy' },
  { label: 'Refund', href: '/refund' },
  { label: 'Cancellation', href: '/cancellation' },
  { label: 'Shipping', href: '/shipping' },
];

export const Footer: React.FC = () => {
  return (
    <UIFooter tone="subtle" size="full">
      <div className="flex flex-col space-y-4">
        <div className="text-center space-y-4">
          <div className="flex items-center justify-center gap-3">
            <div className="w-6 h-6 rounded flex items-center justify-center" style={{ background: 'rgba(255,217,61,0.15)' }}>
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#FFD93D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M9 21V9" />
              </svg>
            </div>
            <span className="font-semibold text-foreground">{FOOTER_NAME}</span>
          </div>

          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '6px 16px', fontSize: 13 }}>
            {footerLinks.map(link => (
              <Link key={link.href} to={route(link.href)} style={{ color: '#666', textDecoration: 'none' }}
                onMouseEnter={e => (e.currentTarget.style.color = '#FFD93D')}
                onMouseLeave={e => (e.currentTarget.style.color = '#666')}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="border-t border-border pt-4">
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} {FOOTER_NAME}. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </UIFooter>
  );
};
